import { Button, ButtonSizeSM, ButtonSkinStatusNegative } from '@picsart/button';
import { memo, useCallback } from 'react';
import cls from 'classnames';
import { createUseStyles } from 'react-jss';

import { AnalyticsGTM } from '../../../../services/analytics-gtm';
import { useLoginStore } from '../LoginStore';

type LoginButtonProps = {
  isFullWidth?: boolean;
  analytics: AnalyticsGTM;
  className?: string;
};

function LoginButton({ isFullWidth, analytics, className }: LoginButtonProps) {
  const classes = useStyles();
  const showPopup = useLoginStore((state) => state.showPopup);
  const onClick = useCallback(() => {
    showPopup();
    analytics.pageClick({
      page_path: window.location.pathname,
      action_type: 'sign_in_click',
    });
  }, []);

  return (
    <div>
      <Button
        size={ButtonSizeSM}
        isFullWidth={isFullWidth}
        skin={ButtonSkinStatusNegative}
        onClick={onClick}
        className={cls(classes.button, className)}
      >
        Sign in
      </Button>
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  button: {
    borderRadius: 12,
    background: 'var(--absolutes-black-package-base-action, #313131)',
    height: 40,
  },
}));

export default memo(LoginButton);
